import React from "react";
import SlideInOutAnimation from "../../util/SlideInOutAnimation";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaFacebookF,
  FaPaperPlane,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaGithub,
} from "react-icons/fa";

function Contact() {
  return (
    <section className="px-6 py-10 bg-black text-white">
      <SlideInOutAnimation>
        <h2 className="text-4xl font-bold text-center mb-24">
          GET IN <span className="text-yellow-500">TOUCH</span>
        </h2>
      </SlideInOutAnimation>

      <div className="grid md:grid-cols-2 gap-12 relative z-10 md:px-20 px-5">
        {/* Left info */}
        <SlideInOutAnimation>
          <h3 className="text-2xl font-bold mb-4">DROP A WORD !</h3>
          <p className="mb-6 text-gray-300">
            Feel free to get in touch with me. I am always open to discussing
            new projects, creative ideas or opportunities to be part of your
            visions.
          </p>

          <div className="flex items-start mb-6">
            <FaMapMarkerAlt className="text-yellow-500 text-2xl mr-4 mt-1" />
            <div>
              <p className="text-sm text-gray-400 uppercase mb-1">
                ADDRESS POINT
              </p>
              <p className="font-bold">Kolkata , India</p>
            </div>
          </div>

          <div className="flex items-start mb-6">
            <FaEnvelope className="text-yellow-500 text-2xl mr-4 mt-1" />
            <div>
              <p className="text-sm text-gray-400 uppercase mb-1">MAIL ME</p>
              <p className="font-bold">cognisolver@gmail.com</p>
            </div>
          </div>

          <div className="flex items-start mb-6">
            <FaPhone className="text-yellow-500 text-2xl mr-4 mt-1" />
            <div>
              <p className="text-sm text-gray-400 uppercase mb-1">CALL ME</p>
              <p className="font-bold">Use email to contact</p>
            </div>
          </div>

          {/* Social Icons */}
          <div className="flex space-x-4 mt-6">
            <a
              href="https://m.facebook.com/bijay.pandey.56232?eav=AfYUrfdxcYb5G_xEwIug3yAdOjFz2AnyM9VG23ztEILtQWK-qKxmJVH7QiFdKfMQmc4&paipv=0"
              className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full hover:bg-yellow-500 transition"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/cognisolver/?utm_source=qr&amp%3Bigshid=NGExMmI2YTkyZg%3D%3D"
              className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full hover:bg-yellow-500 transition"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/in/bijay-pandey/"
              className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full hover:bg-yellow-500 transition"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.youtube.com/@CogniSolver"
              className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full hover:bg-yellow-500 transition"
            >
              <FaYoutube />
            </a>
            <a
              href="https://github.com/CogniSolver"
              className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full hover:bg-yellow-500 transition"
            >
              <FaGithub />
            </a>
          </div>
        </SlideInOutAnimation>

        {/* Form */}
        <SlideInOutAnimation>
          <form className="space-y-4">
            <div className="flex flex-col md:flex-row gap-4">
              <input
                type="text"
                placeholder="Your Name"
                className="flex-1 px-4 py-3 bg-gray-800 text-white rounded-full focus:outline-none"
              />
              <input
                type="email"
                placeholder="Your Email"
                className="flex-1 px-4 py-3 bg-gray-800 text-white rounded-full focus:outline-none"
              />
            </div>
            <input
              type="text"
              placeholder="Your Subject"
              className="w-full px-4 py-3 bg-gray-800 text-white rounded-full focus:outline-none"
            />
            <textarea
              placeholder="Your Message"
              rows="5"
              className="w-full px-4 py-3 bg-gray-800 text-white rounded-2xl focus:outline-none"
            ></textarea>
            <button
              type="submit"
              className="flex items-center gap-3 border border-yellow-500 text-white px-6 py-3 rounded-full hover:bg-yellow-500 hover:text-black transition"
            >
              SEND MESSAGE
              <span className="bg-yellow-500 text-black rounded-full p-2">
                <FaPaperPlane className="w-3 h-3" />
              </span>
            </button>
          </form>
        </SlideInOutAnimation>
      </div>
    </section>
  );
}

export default Contact;
